<template>
  <div>
    <v-card flat color="transparent" class="mt-7">
      <v-toolbar class="bdr secondary2light" :elevation="0" outlined>
        <v-toolbar-title class="grey--text text--darken-2" style="font-size: 18px">
          {{ $t("animal.healthRecord") }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-card>
    <v-card flat class="mt-7" v-if="!showEdit">
      <v-card-text>
        <v-tabs class="tabs-pill" v-model="tab">
          <v-tab class="text-capitalize">{{
              $t("animal.healthRecordInfo.parasiteControl")
          }}</v-tab>
          <v-tab class="text-capitalize">{{
              $t("animal.healthRecordInfo.disease")
          }}</v-tab>
          <v-tab class="text-capitalize">{{
              $t("animal.healthRecordInfo.treatment")
          }}</v-tab>
          <!-- <v-tab class="text-capitalize">{{
              $t("animal.healthRecordInfo.drugHistory")
          }}</v-tab> -->
          <v-tab class="text-capitalize">{{
              $t("animal.healthRecordInfo.vaccination")
          }}</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab" class="mt-5">
          <v-tab-item>
            <ParasiteControl :parasiteControl="parasiteControl" v-if="!$apollo.queries.parasiteControl.loading" @parasiteContol:updated="onParasiteControlUpdated" />
          </v-tab-item>
          <v-tab-item>
            <Disease />
          </v-tab-item>
          <v-tab-item>
            <Treatment :treatment="health" :refreshProp="treatmentRefreshProp"/>
          </v-tab-item>
          <!-- <v-tab-item>
            <DrugHistory :drugHistory="drugHistory" />
          </v-tab-item> -->
          <v-tab-item>
            <Vaccination @vaccination:updated="onVaccinationUpdated" :vaccination="vaccinations" v-if="!$apollo.queries.vaccinations.loading" />
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
    <HealthRecordEdit @health:updated="onHealthUpdated" @health:close="showEdit = false" :_animalHealth="health"
      v-if="showEdit" />
    <prompt-dialog @closeDialog="showPromptDialog = false" @saveData="saveFormData" :dialogI="showPromptDialog"
      v-if="showPromptDialog" />
  </div>
</template>

<script>
import ParasiteControl from "./healthrecord/ParasiteControl.vue";
import Disease from "./healthrecord/Disease.vue";
import Treatment from "./healthrecord/Treatment.vue";
// import DrugHistory from "./healthrecord/DrugHistory.vue";
import Vaccination from "./healthrecord/Vaccination.vue";

import HealthRecordEdit from "./healthrecord/HealthRecordEdit.vue";

import { animalHealth } from "@/graphql/Health.gql";
import PromptDialog from "../common/PromptDialog.vue";
import gql from "graphql-tag";

// import gql from "graphql-tag";

export default {
  apollo: {
    // animalDiseases: {
    //   query: gql`
    //     query animalDiseasesByAnimal($animalId: Int!) {
    //       animalDiseasesByAnimal(animalId: $animalId) {
    //         id
    //         clinicalSymptoms: clinical_symptoms
    //         tentativeDiagnosis: tentative_diagnosis
    //         sampleCollected: sample_collected
    //         veterinarianName: veterinarian_name
    //         diseaseDate: disease_date
    //       }
    //     }
    //   `,
    //   variables() {
    //     return {
    //       animalId: parseInt(this.$route.params.animal_number),
    //     };
    //   },
    //   update: (data) => data.animalDiseasesByAnimal,
    //   error: (err) =>
    //     this.$notify({
    //       title: "Error loading animal diseases!",
    //       text: err,
    //       type: "error",
    //       position: "top right",
    //     }),
    // },
    health: {
      query: animalHealth,
      variables() {
        return {
          animalId: parseInt(this.$route.params.animal_number),
        };
      },
      result() {
        this.loading = false;
      },
      update: data => data.animalHealth || {},
    },
    parasiteControl: {
      query: gql`
        query ParasiteControl($animalId: Int!){
          parasiteControl(animalId: $animalId) {
            id
            purpose
            parasiteDate: parasite_date
            parasiteDrugName: parasite_drug_name
            doseRate: dose_rate
            doseRateUnit: dose_rate_unit
            withdrawalPeriod: withdrawal_period
            withdrawalPeriodUnit: withdrawal_period_unit
            routeOfAdministration: route_of_administration
            remarks
          }
        }
      `,
      variables() {
        return {
          animalId: parseInt(this.$route.params.animal_number),
        };
      },
      fetchPolicy: 'cache-first',
      errorPolicy: 'ignore',
      update: (data) => data.parasiteControl,
      error: (err) =>
        this.$notify({
          title: "Error loading Parasite Control!",
          text: err,
          type: "error",
          position: "top right",
        }),
    },
    vaccinations: {
      query: gql`
        query Vaccinations($animalId: Int!){
          vaccinationHistories(animalId: $animalId) {
            rows {
              id
              administratorName: administrator_name,
              vaccinationAge: vaccination_age,
              vaccinationDate: vaccination_date,
              vaccinationDosage: vaccination_dosage,
              vaccinationDosageUnit: vaccination_dosage_unit,
              vaccinationName: vaccination_name,
              vaccinationType: vaccination_type,
              vaccineRouteOfAdmin: vaccine_route_of_admin,
              revaccinationDate: revaccination_time,
              immunityAfterVaccination: immunity_after_vaccination,
              immunityAfterVaccinationUnit: immunity_after_vaccination_unit,
              immunityLastingPeriod: immunity_lasting_period,
              immunityLastingPeriodUnit: immunity_lasting_period_unit
            }
          }
        }
      `,
      variables() {
        return {
          animalId: parseInt(this.$route.params.animal_number),
        };
      },
      fetchPolicy: 'cache-first',
      errorPolicy: 'ignore',
      update: (data) => data.vaccinationHistories.rows,
      error: (err) =>
        this.$notify({
          title: "Error loading vaccinations!",
          text: err,
          type: "error",
          position: "top right",
        }),
    }
  },
  components: {
    "prompt-dialog": PromptDialog,
    ParasiteControl,
    Disease,
    Treatment,
    // DrugHistory,
    Vaccination,
    HealthRecordEdit,
  },
  watch: {
    tab(nV) {
      if(nV == 2)
        this.treatmentRefreshProp++
    }
  },
  computed: {
    hasChanged() {
      return true;
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.promptNextRoute) {
      next();
    } else {
      if (this.hasChanged && this.showEdit) {
        this.promptToRoute = to;
        this.showPromptDialog = true;
      } else {
        next();
      }
    }
  },
  data() {
    return {
      treatmentRefreshProp: 0,
      loading: true,
      noRecord: true,
      showEdit: false,
      tab: null,
      showPromptDialog: false,
      promptToRoute: null,
      promptNextRoute: false,
      defaultData: {},
      parasiteControl: []
    };
  },
  methods: {
    saveFormData(answer) {
      this.showPromptDialog = false;
      if (!answer) {
        this.promptNextRoute = true;
        this.$router.push(this.promptToRoute);
      }
    },
    onHealthUpdated() {
      this.$apollo.queries.health.refetch();
      this.showEdit = false;
    },
    onParasiteControlUpdated() {
      this.$apollo.queries.parasiteControl.refetch();
    },
    onVaccinationUpdated() {
      this.$apollo.queries.vaccinations.refetch();
    },
  },
};
</script>

<style lang="scss" scoped>
.bdr {
  border: thin solid $secondary-color;
}
</style>
